import BaseRepository from '@/api/repositories/BaseRepository';

export default class InvitationsRepository extends BaseRepository {
	getInvitations() {
		return this.get('invitations', {});
	}

	sendInvitation(invitation) {
		return this.post('invitations', {}, invitation);
	}

	resendInvitation(id) {
		return this.post(`invitations/${id}/resend`);
	}
}